import { default as cleanupPolicyDocuments } from './cleanupPolicyDocuments';
import { default as downloadDigitalId } from './downloadDigitalId';

export function getPolicyDocumentCenterHelpers() {
  return {
    cleanupPolicyDocuments,
    downloadAppleWallet: downloadDigitalId.downloadAppleWallet,
    downloadAndroidWallet: downloadDigitalId.downloadAndroidWallet,
  };
}
